import { useSearchParams, Link } from "react-router-dom";
import { ArrowLeft, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import SEOHead from "@/components/SEOHead";

const ResourceViewer = () => {
  const [searchParams] = useSearchParams();
  const file = searchParams.get("file");
  
  if (!file) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <SEOHead 
          title="자료를 찾을 수 없습니다 - Central TG"
          description="요청하신 자료를 찾을 수 없습니다."
          noindex
        />
        <div className="text-center p-6">
          <h1 className="text-2xl font-bold text-foreground mb-4">자료를 찾을 수 없습니다</h1>
          <p className="text-muted-foreground mb-6">요청하신 PDF 파일이 없습니다.</p>
          <Link to="/resources">
            <Button>
              <ArrowLeft className="w-4 h-4 mr-2" />
              자료실로 돌아가기
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  const pdfUrl = `/resources/${file}`;
  const fileName = file.replace(/-/g, " ").replace(".pdf", "");

  return (
    <div className="h-screen w-screen flex flex-col bg-background">
      <SEOHead 
        title={`${fileName} - Central TG 연구자료`}
        description={`JAX® 연구 자료: ${fileName}`}
        noindex
      />
      
      {/* PDF Embed - Full Screen */}
      <iframe
        src={pdfUrl}
        className="w-full h-full flex-1"
        title={fileName}
      />
    </div>
  );
};

export default ResourceViewer;
